import {getRequest, putRequest} from "../../httpClient";



export async function fetchNotifications(token) {
    return  await getRequest(`/v3/notifications`, token)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}

export async function markNotificationAsRead(token, notificationId) {


    return  await putRequest(`/v3/notifications/read/${notificationId}`, token)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}

export async function markNotificationAsUnRead(token, notificationId) {

    return  await putRequest(`/v3/notifications/unread/${notificationId}`, token)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}
